var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-box"},[_c('div',{staticClass:"image-box"},[_c('img',{attrs:{"src":_vm.emptyImage}}),_c('p',{style:({ marginTop: _vm.textTop })},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }